if (!customElements.get('products-toolbar')) {
  class ProductsToolbar extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.filtersComponent = document.querySelector('facet-filters');
      this.filtersColumn = document.querySelector('.main-products-grid__filters');
      this.layoutSwitcher = this.querySelector('.products-toolbar__layout');
      this.compareToggle = document.getElementById('compare-switch');
      this.sortBy = this.querySelector('.products-toolbar__sort');
      this.productsGrid = document.querySelector('.main-products-grid');
      this.wholesaleToggle = this.querySelector('.products-toolbar__wholesale-toggle');

      if (this.filtersColumn) {
        this.filterToggle = this.querySelector('.js-toggle-filters');
        this.filterToggle.addEventListener('click', this.toggleFilters.bind(this));
      }

      if (this.layoutSwitcher) {
        this.layoutSwitcher.addEventListener('change', this.handleLayoutChange.bind(this));

        // Set the layout to the layout in localstorage
        const layout = theme.storageUtil.get('products-layout');
        if (layout && layout === 'list') {
          const toggle = document.getElementById(`${layout}-layout-opt`);
          if (toggle) toggle.click();
          this.handleLayoutChange(null, layout);
        }
      }

      // Wholesale view toggle
      if (this.wholesaleToggle) {
        this.initWholesaleToggle();
      }

      if (this.compareToggle) {
        this.compareToggle.addEventListener('change', this.toggleCompare.bind(this));

        const isChecked = theme.storageUtil.get('compare-toggle', true);
        if (isChecked !== null) {
          this.toggleCompare(null, isChecked, true);
        } else {
          this.toggleCompare(null, this.compareToggle.checked, false);
        }

        setTimeout(() => {
          this.classList.add('transition-ready');
          this.productsGrid.classList.add('transition-ready');
        }, 500);
      } else if (theme.settings.compareToggle === 'none') {
        this.toggleCompare(null, true, false);
      }

      if (!this.filtersComponent && this.sortBy) {
        this.sortBy.addEventListener('change', ProductsToolbar.handleSortByChange);
      }
    }

    /**
     * Initialize wholesale view toggle
     */
    initWholesaleToggle() {
      const gridBtn = this.wholesaleToggle.querySelector('[data-view="grid"]');
      const tableBtn = this.wholesaleToggle.querySelector('[data-view="table"]');
      
      // Target the product grid (ul.grid) and table view within the same results container
      const productGrid = document.querySelector('.main-products-grid__results ul.grid');
      const tableView = document.querySelector('.main-products-grid__results .wholesale-table-view');

      if (!productGrid || !tableView) {
        console.error('Could not find product grid or table view');
        console.error('Product grid element:', productGrid);
        console.error('Table view element:', tableView);
        return;
      }

      console.log('Wholesale toggle initialized successfully');
      console.log('Product grid element:', productGrid);
      console.log('Product grid computed styles:', window.getComputedStyle(productGrid).display);

      const setView = (view) => {
        console.log('Setting view to:', view);
        if (view === 'grid') {
          gridBtn?.classList.add('active');
          tableBtn?.classList.remove('active');
          productGrid.classList.remove('hidden');
          tableView.classList.add('hidden');
          console.log('Grid view activated');
          console.log('Grid display after activation:', window.getComputedStyle(productGrid).display);
        } else {
          gridBtn?.classList.remove('active');
          tableBtn?.classList.add('active');
          productGrid.classList.add('hidden');
          tableView.classList.remove('hidden');
          console.log('Table view activated');
        }
        localStorage.setItem('wholesale_view_preference', view);
      };

      // Check for saved preference
      const savedView = localStorage.getItem('wholesale_view_preference') || 'grid';
      setView(savedView);

      // Event listeners
      gridBtn?.addEventListener('click', () => {
        console.log('Grid button clicked');
        setView('grid');
      });
      tableBtn?.addEventListener('click', () => {
        console.log('Table button clicked');
        setView('table');
      });
    }

    /**
     * Updates the UI to reflect the compare state
     * @param {object} evt - Change event object
     * @param {boolean} checked - Whether compare is enabled or not (optional)
     * @param {boolean} persist - Whether to persist the new state (optional)
     */
    toggleCompare(evt, checked = null, persist = true) {
      const isChecked = evt ? evt.target.checked : checked;
      this.productsGrid.dataset.compare = isChecked;

      const compareButton = document.getElementById('compare-drawer-open');
      compareButton.classList.toggle('is-out', !isChecked);

      if (!evt && this.compareToggle) this.compareToggle.checked = isChecked;

      if (persist && !Shopify.designMode) {
        theme.storageUtil.set('compare-toggle', isChecked);
      }

      // Load scripts/styles if not already loaded
      if (isChecked) {
        const resourcesTag = document.getElementById('compare-resources');
        if (resourcesTag) {
          const resources = JSON.parse(resourcesTag.textContent);
          resources.forEach((resource) => {
            if (resource.type === 'js') {
              const script = document.createElement('script');
              script.src = resource.path;
              document.head.appendChild(script);
            } else if (resource.type === 'css') {
              const link = document.createElement('link');
              link.href = resource.path;
              link.type = 'text/css';
              link.rel = 'stylesheet';
              document.head.appendChild(link);
            }
          });
          resourcesTag.remove();
        }
      }
    }

    /**
     * Toggles open/closed state of the filters on desktop.
     */
    toggleFilters() {
      this.filterToggle.classList.toggle('is-active');
      this.filtersOpen = this.filterToggle.classList.contains('is-active');
      this.filterToggle.setAttribute('aria-expanded', this.filtersOpen);

      // Wholesale table view hides the grid (and its filter sidebar), so the
      // facets show as a dropdown panel there (see facet-filters.css). Facet
      // changes auto-apply, so no apply footer is needed.
      const tableViewActive = document.body.classList.contains('qow-table-view');

      if (theme.mediaMatches.lg && tableViewActive) {
        if (this.filtersOpen) {
          this.openQowDropdown();
        } else {
          this.closeQowDropdown(false);
        }
      } else if (theme.mediaMatches.lg) {
        this.filtersColumn.classList.toggle('lg:js-hidden', !this.filtersOpen);
        const productsList = document.querySelector('.main-products-grid__results > .grid');

        productsList.className = this.filtersOpen
          ? productsList.dataset.filtersOpenClasses
          : productsList.dataset.filtersClosedClasses;
      } else {
        this.filtersComponent.open();
      }
    }

    /**
     * Opens the wholesale table-view filter dropdown, anchored under the
     * Filter button, with outside-click and close-button dismissal.
     */
    openQowDropdown() {
      this.filtersComponent.classList.add('qow-dropdown-open');
      this.positionQowDropdown();

      this.qowReposition = this.positionQowDropdown.bind(this);
      window.addEventListener('scroll', this.qowReposition, { passive: true });
      window.addEventListener('resize', this.qowReposition);

      this.qowDismiss = (evt) => {
        if (evt.target.closest('.js-close-drawer')) {
          evt.preventDefault();
          this.closeQowDropdown(true);
        } else if (!this.filtersComponent.contains(evt.target)
          && !this.filterToggle.contains(evt.target)) {
          this.closeQowDropdown(true);
        }
      };
      // Capture phase so dismissal wins over other handlers
      setTimeout(() => document.addEventListener('click', this.qowDismiss, true), 0);
    }

    positionQowDropdown() {
      const rect = this.filterToggle.getBoundingClientRect();
      this.filtersComponent.style.top = `${Math.round(rect.bottom + 8)}px`;
      this.filtersComponent.style.left = `${Math.round(rect.left)}px`;
    }

    closeQowDropdown(syncToggle) {
      this.filtersComponent.classList.remove('qow-dropdown-open');
      window.removeEventListener('scroll', this.qowReposition);
      window.removeEventListener('resize', this.qowReposition);
      document.removeEventListener('click', this.qowDismiss, true);

      if (syncToggle) {
        this.filtersOpen = false;
        this.filterToggle.classList.remove('is-active');
        this.filterToggle.setAttribute('aria-expanded', 'false');
      }
    }

    /**
     * Handles 'change' events on the layout switcher buttons.
     * @param {object} evt - Event object.
     * @param {string} layout - 'grid' or 'list' - the layout to change to.
     */
    handleLayoutChange(evt, layout) {
      this.productsGrid.dataset.layout = layout || evt.target.value;
      if (!layout) theme.storageUtil.set('products-layout', evt.target.value);
    }

    /**
     * Handles when a sort by dropdown is changed (and filtering is disabled)
     * @param {object} evt - Event object.
     */
    static handleSortByChange(evt) {
      const urlObj = new URL(window.location.href);
      urlObj.searchParams.set('sort_by', evt.detail.selectedValue);
      urlObj.hash = 'products-toolbar';
      window.location.href = urlObj.toString();
    }
  }

  customElements.define('products-toolbar', ProductsToolbar);
}
